import { render } from "./VoteBox.vue?vue&type=template&id=01445cfd&scoped=true"
import script from "./VoteBox.vue?vue&type=script&lang=js"
export * from "./VoteBox.vue?vue&type=script&lang=js"

import "./VoteBox.vue?vue&type=style&index=0&id=01445cfd&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01445cfd"]])

export default __exports__